module.exports = __webpack_public_path__ + "b92e5ba818b8c76bae15c42fdd20b682.png";